import { NgModule } from '@angular/core'
import { RouterModule, Routes } from '@angular/router'

import { AdminGuard } from './guards/admin.guard'
import { CustomerGuard } from './guards/customer.guard'

import { HomeComponent } from './com/home/home.com'

const AdminRoutes: Routes = [
  { path: '', component: HomeComponent },
  { path: 'auth', loadChildren: './modules/auth/auth.module#AuthModule' },
  { path: 'inventory', loadChildren: './modules/inventory/inventory.module#InventoryModule', canActivate: [ AdminGuard ] },
  { path: 'import', loadChildren: './modules/import/import.module#ImportModule', canActivate: [ AdminGuard ] },
  { path: 'batches', loadChildren: './modules/batches/batches.module#BatchesModule', canActivate: [ AdminGuard ] },
  { path: 'finance', loadChildren: './modules/finance/finance.module#FinanceModule', canActivate: [ AdminGuard ] },
  { path: 'operation', loadChildren: './modules/operation/operation.module#OperationModule', canActivate: [ AdminGuard ] },
  { path: 'about', loadChildren: './modules/about/about.module#AboutModule' },
  { path: '**', redirectTo: '' }
]

@NgModule({
  imports: [ RouterModule.forRoot(AdminRoutes) ],
  exports: [ RouterModule ]
})

export class AppRoutingModule {}



// WEBPACK FOOTER //
// ./src/app/app-routing.module.ts